import type { Transaction } from './types';

/**
 * A concierge deposit is paid with a member of staff in a chat. The client sees the chat in every
 * state — never a requisite screen, never a redirect — and keeps it after the deposit ends: the
 * outcome is shown above the feed and the conversation stays open.
 */
export const isConciergeChat = (
  transaction: Pick<Transaction, 'status'> & { concierge?: boolean } | null | undefined,
): boolean => transaction?.concierge === true;
